import React from 'react';
import Box from '@mui/material/Box';

const Skill: React.FC<{
    name: string
}> = ({ name }) => {

    return (
        <Box
            sx={{
                p: 0,
                m: 0
            }}
        >
            {name}
        </Box>
    )
}

export default Skill;